import { getCookie } from "cookies-next";
import secretApiAxios from "../endpoints/core/secretApiAxios";
/**
 * # Salvamento de Monitoramento das ações dentro do projeto
 * 
 * @param {*} oper Este parâmetro deve ser inserido através de associação de Array, em TagLogs
 *  - Visitar o arquivo que exporta TagLogs para mais detalhes 
 *  - Importar TagLogs e acessar as tags para obter o texto adequado
 *  - Ex: `SetLog(TagLogs.[[log_name]])`
 * 
 * @param {*} dataLog JSON com retalhes da operação, caso queira salvar informações adicionais
 * @param {*} dataResult Resultado da operação, sendo true como captura apenas de monitoramento, ou false quando houver falha
 * @returns null
 */
export const SetLog = async (
  oper, // STRING
  dataLog, // JSON
  dataResult // Bool
) => {

  const email = getCookie('electy-server@user-email');

  if (typeof window === 'undefined') {
    console.log("Server", email)
    return await secretApiAxios.post(`${process.env.SECRET_APP_API_URL}system-logs`, {
      data: {
        operacao: oper,
        data_log: JSON.stringify(dataLog),
        result: dataResult == true ? true : (dataResult == false ? false: null)
      }
    });
  } else {
    console.log("Client", email)
    return await secretApiAxios.post(`${process.env.PUBLIC_APP_API_URL}system-logs`, {
      data: {
        operacao: oper,
        data_log: JSON.stringify(dataLog), 
        result: dataResult == true ? true : (dataResult == false ? false : null)
      }
    });

  }
};

/**
 * # COMBINADO COM SetLog(...)
 * 
 * ## Jeito correto de usar SetLog:
 * - `SetLog(TagLogs.[[nome_da_tag]], ...)`
 * - `SetLog(TagLogs.dispath_hook_update, ...)`
 * 
 * ## Jeito errado de usar SetLog:
 * - SetLog('MONITORAMENTO DE EVENTO XXX', ...)
 * 
 * O primeiro parametro da chamada SetLog precisa ser tratado no array TagLogs.
 * Significa que cada texto precisa seguir um padrão de tag conforme expecificado
 * 
 * Havendo necessidade de uma tag específica, é importante que seja incluído nesse array
 * posteriormente utilizado na função a partir do array.
 * 
 * 
 */
export const TagLogs = {  
  // MONITORING TAGS
  dispath_hook_update: "[MONITORAMENTO] DispathHookUpdate",

  // ERROR TAGS
  error_generic: "[ERROR]",
  error_dispath_hook_update: "[ERROR] DispathHookUpdate",
  error_details_dispath_hook_update: "[ERROR - DETAILS] DispathHookUpdate",
  error_query_dispath_hook_update: "[ERROR - QUERY] DispathHookUpdate",
  error_create_lead: '[ERROR] CREATE LEAD',
  error_update_lead: '[ERROR] UPDATE LEAD',
  error_save_lead: '[ERROR] SAVE LEAD',
  error_find_lead: '[ERROR] FIND LEAD',
  error_create_card_pipefy_fallback: 'Create Card Pipefy - Fallback',
  error_sharpspring: '[ERROR] SHARPSPRING',
  error_cep_fallback: '[ERROR] Busca CEP - Fallback',
  error_calculadora_invalid_params: '[ERRO] CALCULADORA - Validação de Campos',
  error_calculadora: '[ERRO] CALCULADORA - Captura de Erro Genérica',
  error_sendcontract_email: '[ERROR] ENVIO DE E-MAIL - SendContract',
  error_sendregisterlink_email: '[ERROR] ENVIO DE E-MAIL - SendLinkRegister',
};
